"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _withModules = _interopRequireDefault(require("./withModules.png"));
var _Mediator = _interopRequireDefault(require("./Mediator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'module',
  label: 'Modules',
  thumbnail: _withModules["default"],
  mediatorComponent: _Mediator["default"]
};